import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from "./home/home.component";
import {LoginComponent} from "./login/login.component";
import {RegisterComponent} from "./register/register.component";
import {ContactComponent} from "./contact/contact.component";
import {FaqComponent} from "./faq/faq.component";
import {EventsOverviewComponent} from "./events-overview/events-overview.component";
import {EventPageComponent} from "./event-page/event-page.component";
import {EventCreateComponent} from "./event-create/event-create.component";
import {ThankYouComponent} from "./thank-you/thank-you.component";
import {EventDetailPageComponent} from "./event-detail-page/event-detail-page.component";
import {AuthGuardService} from "./services/authguard.service";
import {AdminGuardService} from "./services/adminguard.service";
import {RegisterOrganizationComponent} from "./register-organization/register-organization.component";
import {OrganizationsComponent} from "./organizations/organizations.component";
import {ErrorComponent} from "./error/error.component";
import {PrivacyComponent} from "./privacy/privacy.component";
import {ProfilePageComponent} from "./profile-page/profile-page.component";
import {ProfileDetailsComponent} from "./profile-details/profile-details.component";
import {ProfileEventsOverviewComponent} from "./profile-events-overview/profile-events-overview.component";
import {SupportComponent} from "./support/support.component";
import {PasswordForgottenComponent} from "./password-forgotten/password-forgotten.component";
import {PasswordChangeComponent} from "./password-change/password-change.component";
import {EmailChangeComponent} from "./email-change/email-change.component";
import {AdminUserManageComponent} from "./admin-user-manage/admin-user-manage.component";
import {AdminActivityManageComponent} from "./admin-activity-manage/admin-activity-manage.component";
import {AdminOrganizationManageComponent} from "./admin-organization-manage/admin-organization-manage.component";
import {AdminUserDetailComponent} from "./admin-user-detail/admin-user-detail.component";
import {AdminOrganizationDetailComponent} from "./admin-organization-detail/admin-organization-detail.component";
import {AdminActivityDetailComponent} from "./admin-activity-detail/admin-activity-detail.component";
import {MyOrganizationComponent} from "./my-organization/my-organization.component";
import {MyOrganizationDetailsComponent} from "./my-organization-details/my-organization-details.component";
import {
  MyOrganizationEventsOverviewComponent
} from "./my-organization-events-overview/my-organization-events-overview.component";
import {
  MyOrganizationAddressChangeComponent
} from "./my-organization-address-change/my-organization-address-change.component";
import {
  MyOrganizationEmailChangeComponent
} from "./my-organization-email-change/my-organization-email-change.component";
import {
  MyOrganizationContactChangeComponent
} from "./my-organization-contact-change/my-organization-contact-change.component";

const routes: Routes = [
  {
    path: 'home',
    title: 'Steddie | Altijd een goed idee!',
    component: HomeComponent
  },
  {
    path: 'activiteiten',
    title: 'Steddie | Activiteiten',
    component: EventsOverviewComponent
  },
  {
    path: 'account',
    children:
      [
        {
          path: 'inloggen',
          title: 'Steddie | Inloggen',
          component: LoginComponent
        },
        {
          path: 'registreren',
          title: 'Steddie | Registreren',
          component: RegisterComponent
        },
        {
          path: 'wachtwoord-vergeten',
          title: 'Steddie | Wachtwoord vergeten',
          component: PasswordForgottenComponent
        },
        {
          path: 'registreren-organisatie',
          title: 'Steddie | Registreren organisatie',
          component: RegisterOrganizationComponent
        },
      ],
  },
  {
    path: 'admin',
    canActivate: [AdminGuardService],
    children:
      [
        {
          path: 'beheer-gebruikers',
          title: 'Steddie | Beheer gebruikers',
          component: AdminUserManageComponent
        },
        {
          path: 'beheer-gebruikers/:id',
          title: 'Steddie | Beheer gebruiker',
          component: AdminUserDetailComponent
        },
        {
          path: 'beheer-activiteiten',
          title: 'Steddie | Beheer activiteiten',
          component: AdminActivityManageComponent
        },
        {
          path: 'beheer-activiteiten/:id',
          title: 'Steddie | Beheer activiteit',
          component: AdminActivityDetailComponent
        },
        {
          path: 'beheer-organisaties',
          title: 'Steddie | Beheer organisaties',
          component: AdminOrganizationManageComponent
        },
        {
          path: 'beheer-organisaties/:id',
          title: 'Steddie | Beheer organisatie',
          component: AdminOrganizationDetailComponent
        },
      ],
  },
  {
    path: 'activiteit',
    children: [
      {
        path: 'aanmaken',
        title: 'Steddie | Activiteit aanmaken',
        component: EventCreateComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: ':id',
        title: 'Steddie | Activiteit',
        component: EventPageComponent
      },
      {
        path: 'details/:id',
        title: 'Steddie | Activiteit details',
        component: EventDetailPageComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'wijzigen/:id',
        title: 'Steddie | Activiteit wijzigen',
        component: EventCreateComponent,
        canActivate: [AuthGuardService]
      }
    ]
  },
  {
    path: 'bedankt/:id',
    title: 'Steddie | Bedankt voor je bijdrage!',
    component: ThankYouComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'contact',
    title: 'Steddie | Contactpagina',
    component: ContactComponent
  },
  {
    path: 'faq',
    title: 'Steddie | Veel gestelde vragen',
    component: FaqComponent
  },
  {
    path: 'steun-steddie',
    title: 'Steddie | Steun ons!',
    component: SupportComponent
  },
  {
    path: 'privacy',
    title: 'Steddie | Privacyverklaring',
    component: PrivacyComponent
  },
  {
    path: 'organisaties',
    title: 'Steddie | Voor organisaties',
    component: OrganizationsComponent
  },
  {
    path: 'profiel',
    canActivate: [AuthGuardService],
    children:
      [
        {
          path: 'gegevens',
          title: 'Steddie | Account gegevens',
          component: ProfileDetailsComponent
        },
        {
          path: 'gegevens/wachtwoord-wijzigen',
          title: 'Steddie | Wachtwoord wijzigen',
          component: PasswordChangeComponent
        },
        {
          path: 'gegevens/email-wijzigen',
          title: 'Steddie | E-mailadres wijzigen',
          component: EmailChangeComponent
        },
        {
          path: 'activiteiten',
          title: 'Steddie | Aangemelde activiteiten',
          component: ProfileEventsOverviewComponent
        },
        {
          path: '',
          title: 'Steddie | Mijn profiel',
          component: ProfilePageComponent
        }
      ]
  },
  {
    path: 'mijn-organisatie',
    canActivate: [AuthGuardService],
    children:
      [
        {
          path: 'gegevens',
          title: 'Steddie | Organisatie gegevens',
          component: MyOrganizationDetailsComponent
        },
        {
          path: 'gegevens/adres-wijzigen',
          title: 'Steddie | Organisatie adres wijzigen',
          component: MyOrganizationAddressChangeComponent
        },
        {
          path: 'gegevens/contact-wijzigen',
          title: 'Steddie | Organisatie contactgegevens wijzigen',
          component: MyOrganizationContactChangeComponent
        },
        {
          path: 'gegevens/email-wijzigen',
          title: 'Steddie | Organisatie e-mailadres wijzigen',
          component: MyOrganizationEmailChangeComponent
        },
        {
          path: 'activiteiten',
          title: 'Steddie | Organisatie activiteit overzicht',
          component: MyOrganizationEventsOverviewComponent
        },
        {
          path: '',
          title: 'Steddie | Mijn organisatie',
          component: MyOrganizationComponent
        }
      ]
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: '**',
    title: 'Steddie | Er is iets foutgegaan!',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
